import React from 'react';
import c from 'classnames';
import FragmentsIcon from '@wix/da-ds/pkg/Icons/Fragments';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './FragmentsValue.scss';
const FragmentsValue = ({ className, isInline, amount, iconSize = IconSize.SMALL })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className, isInline && s['inline'])
    }, /*#__PURE__*/ React.createElement(FragmentsIcon, {
        size: iconSize,
        className: c(isInline && s['inline-icon'])
    }), amount);
};
FragmentsValue.displayName = 'FragmentsValue';
export default FragmentsValue;

//# sourceMappingURL=FragmentsValue.js.map